import { Button } from 'internalLibrary';

interface WelcomeBackTextAndButtonProps {
  loanAmount: number;
  onClick: () => void;
  buttonDisabled: boolean;
}

function WelcomeBackTextAndButton({
  loanAmount,
  onClick,
  buttonDisabled,
}: WelcomeBackTextAndButtonProps) {
  return (
    <div style={{ maxWidth: '650px' }}>
      <h1
        style={{
          fontWeight: 500,
          fontSize: '36px',
          lineHeight: '40px',
          letterSpacing: '-.35px',
        }}
      >
        Gör dig redo för en nystart!
      </h1>
      <div
        style={{
          fontWeight: 400,
          fontSize: '18px',
          lineHeight: '22px',
          marginBottom: '40px',
        }}
      >
        <p>
          Du kan nu ansöka om ett nytt lån på {loanAmount} kr. eller anpassa
          beloppet och försöka igen.
        </p>

        <p>
          Tack för att du väljer oss som din finansiella partner. Vi värdesätter
          ditt förtroende och ser fram emot att hjälpa dig att uppnå dina mål.
        </p>
      </div>
      <Button onClick={onClick} disabled={buttonDisabled}>
        Ansök
      </Button>
    </div>
  );
}

export default WelcomeBackTextAndButton;
